import React from 'react';
import { useLocation } from 'react-router-dom';

export default function ActualPage() {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter(x => x);

    const pageNames = {
        "home": "Accueil",
        "recherche-avancee": "Recherche avancée",
        "a-propos": "À propos",
        "contact": "Contact",
        "recherche": "Recherche rapide",
        "detail": `Détail`
    };

    if (location.pathname === '/') {
        return null;
    }

    return (
        <div className="flex ml-5" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                <li className="inline-flex items-center">
                    <svg className="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
                    </svg>
                    <a href="/" className="inline-flex items-center text-sm font-medium hover:text-blue-900">
                        {pageNames["home"]}
                    </a>
                </li>
                {pathnames.map((value, index) => {
                    const isLast = index === pathnames.length - 1;
                    const to = `/${pathnames.slice(0, index + 1).join('/')}`;

                    return (
                        <li key={to} className={isLast ? "inline-flex items-center" : ""} aria-current={isLast ? "page" : undefined}>
                            <div className="flex items-center">
                                <svg className="rtl:rotate-180 w-3 h-3 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
                                </svg>
                                <a href={to} className="ms-1 text-sm font-medium hover:text-blue-900 md:ms-2">{pageNames[value]}</a>
                            </div>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
}